export const educationIdsMap = {
  'Associates Degree': 9001,
  'Bachelors Degree': 9002,
  'CELTA': 116,
  'Computer Science': 109,
  'Doctorate Degree': 9004,
  'English': 108,
  'ESL/ELL': 110,
  'Gifted': 111,
  'I am a current undergraduate student': 9000,
  'I am a current graduate student': 9000,
  'I have a Associate\'s Degree': 9001,
  'I have a Bachelor\'s Degree': 9002,
  'I have a Master\'s Degree': 9003,
  'I have a Doctorate / PhD': 9004,
  'Math': 106,
  'Masters Degree': 9003,
  'Other': 114,
  'Science': 107,
  'Some college (at least 12 credit hours)': 9000,
  'Special Education': 105,
  'Structured Literacy Pratice': 112
};

export const subjectIdsMap = {
  'ACT': 40,
  'ACT Math': 108,
  'Algebra': 2,
  'Anatomy & Physiology': 792,
  'AP Biology': 343,
  'AP Calculus AB': 336,
  'AP Calculus BC': 337,
  'AP Chemistry': 339,
  'AP Computer Science A': 816,
  'AP Computer Science Principles': 817,
  'AP English Language and Composition': 144,
  'AP Macroeconomics': 379,
  'AP Microeconomics': 380,
  'AP Physics 1': 375,
  'AP Physics C: Mechanics': 794,
  'AP Statistics': 372,
  'ARRT': 1470,
  'Astronomy': 24,
  'Bar Exam': 1213,
  'Biochemistry': 159,
  'Biology': 16,
  'Business Calculus': 716,
  'C++': 295,
  'Calculus': 3,
  'Calculus 2': 4,
  'Calculus 3': 5,
  'Certified Reading Intervention': 2907,
  'Chemistry': 17,
  'Chinese': 1563,
  'College Algebra': 168,
  'College Business': 90,
  'College Biology': 712,
  'College Chemistry': 725,
  'College Computer Science': 728,
  'College Economics': 730,
  'College English': 733,
  'College Math': 524,
  'College Physics': 788,
  'College Application Essays': 782,
  'Computer Game Design': 575,
  'Computer Programming': 443,
  'Conversational Spanish': 815,
  'CPA': 783,
  'CSET': 1326,
  'Drawing': 528,
  'Differential Equations': 6,
  'Discrete Math': 677,
  'Elementary School': 784,
  'Elementary School Math': 775,
  'Elementary School English': 1209,
  'Elementary School Reading': 734,
  'Elementary School Science': 796,
  'Elementary School Writing': 735,
  'English Grammar and Syntax': 67,
  'Essay Editing': 64,
  'Executive Functioning': 120,
  'FE Exam': 1343,
  'French': 27,
  'French 1': 671,
  'Finance': 86,
  'Financial Accounting': 688,
  'GMAT': 42,
  'GRE': 43,
  'Geometry': 7,
  'High School Biology': 714,
  'High School Chemistry': 727,
  'High School Computer Science': 729,
  'High School English': 737,
  'High School Physics': 789,
  'High School World History': 750,
  'High School Writing': 859,
  'History': 70,
  'HSPT': 44,
  'IB Computer Science': 829,
  'IB Mathematics': 778,
  'ISEE': 46,
  'ISEE- Middle Level': 266,
  'ISEE- Upper Level': 267,
  'Japanese': 31,
  'Java': 296,
  'Linear Algebra': 268,
  'LSAT': 47,
  'Managerial Accounting': 689,
  'Marketing': 548,
  'MBLEX': 1297,
  'MCAT': 49,
  'Microeconomics': 74,
  'Microsoft Excel': 836,
  'Microsoft Office': 837,
  'Mechanical Engineering': 275,
  'Middle School': 483,
  'Middle School English': 1210,
  'Middle School Math': 9,
  'Middle School Reading': 738,
  'Middle School Reading Comprehension': 861,
  'Middle School Writing': 739,
  'Middle School Science': 802,
  'MPJE': 2185,
  'Multivariable Calculus': 113,
  'Music': 91,
  'NCLEX': 785,
  'NAPLEX - National Association Boards of Pharmacy': 1335,
  'NMLS - National Mortgage Licensing System': 1329,
  'NPTE': 1299,
  'Organic Chemistry': 18,
  'Orton Gillingham': 2892,
  'Phonics': 65,
  'Physics': 21,
  'Physical Chemistry': 20,
  'PRAXIS': 856,
  'Pre-Algebra': 294,
  'Pre-Calculus': 10,
  'Psychology': 76,
  'Public Speaking': 300,
  'PSAT': 48,
  'Python': 682,
  'Reading': 62,
  'Real Analysis': 2414,
  'Real Estate License': 2642,
  'SAT': 50,
  'SAT Math': 104,
  'Science': 14,
  'Series 65': 1271,
  'Series 7': 857,
  'SHSAT': 121,
  'SIE': 1226,
  'Social Studies': 69,
  'Spanish': 35,
  'Spanish 1': 673,
  'Spanish 2': 325,
  'Spanish 3': 326,
  'Spanish 4': 327,
  'Special Education': 126,
  'SSAT': 52,
  'SSAT- Middle Level': 329,
  'SSAT- Upper Level': 330,
  'Statistics': 11,
  'Study Skills And Organization': 119,
  'Trigonometry': 12
};
